module.exports = __webpack_public_path__ + "src/assets/models/serological/test_tube_red_5.fbx";